module.exports = __webpack_public_path__ + "static/media/29090037-42B0wSgs.608f4729.JPG";